interface AlphaBoldMarkProps {
  /** Rendered height in px; width scales with the mark's portrait aspect ratio. */
  size?: number
  className?: string
}

/**
 * AlphaBOLD brand mark — the gold tile with the two-tone arrow, rendered from the
 * official logo asset (frontend/public/alphabold-mark.png). Single source of
 * truth so the sidebar, login screen and any future placements stay consistent.
 */
export default function AlphaBoldMark({ size = 34, className = '' }: AlphaBoldMarkProps) {
  return (
    <img
      src="/alphabold-mark.png"
      alt="AlphaBOLD"
      style={{ height: size, width: 'auto' }}
      className={className}
      draggable={false}
    />
  )
}
